import { Vector } from '../types/vector/vector';

export class SceneLightData {
  name = '';
  direction = new Vector();
  position = new Vector();
  intensity = 0.0;
  castShadows = false;
  shadowDarkness = 0;
}
